import { useEffect, useState } from 'react';

/** The original value will be returned if the delay is falsy. */
export function useDebounce<T>(value: T, delay: number | undefined) {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		if (!delay) {
			return undefined;
		}
		const timerId = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => {
			clearTimeout(timerId);
		};
	}, [value, delay]);

	return delay ? debouncedValue : value;
}
